import { userRoleLevels, userRoles } from 'features/UserPermissions'
import { useSelector } from 'react-redux'

import UserPermissionCheckbox from './UserPermissionCheckbox'

const UserPermissionSubColumn = ({
  userPermissions,
  permissionName,
  handleUpgradeClick,
  handleDowngradeClick,
  title,
  checkboxHeight = 90,
  updateRole,
  showHeader = true
}) => {
  const isIndependentlyManaged = useSelector(s => s.hotelDetails.isIndependentlyManaged)

  function checkIfUpgradeAble(role, isInternalGlobalUser) {
    if (isIndependentlyManaged) {
      return false
    }

    if (isInternalGlobalUser) {
      return false
    }

    if (role === 'Billing') {
      return true
    }

    if (role === 'UserManage') {
      return true
    }

    if (role === 'CampaignManage') {
      return true
    }

    return false
  }

  function checkIsDisabled(role, hasCampaignsManageAccess) {
    // business logic
    return (
      [
        userRoles.ChatInProperty,
        userRoles.ChatSalesAfter,
        userRoles.ChatDirect,
        userRoles.ReportsView
      ].includes(role) && hasCampaignsManageAccess
    )
  }

  return (
    <div
      className={`userPermissionSubColumn ${
        permissionName === 'billing' && 'billingCol'
      }`}
    >
      {showHeader && <div className="userPermissionSubColumn__header">{title}</div>}
      <div className="userPermissionSubColumn__content">
        {userPermissions.map(
          ({
            role,
            userId,
            accessLevel,
            isInternalGlobalUser,
            name,
            hasCampaignsManageAccess
          }) => (
            <UserPermissionCheckbox
              id={userId + role}
              key={userId + role}
              label={`${name} ${role}`}
              userId={userId}
              role={role}
              height={checkboxHeight}
              disabled={checkIsDisabled(role, hasCampaignsManageAccess)}
              handleChange={e =>
                updateRole(
                  userId,
                  role,
                  e.target.checked
                    ? userRoleLevels.HasPermission
                    : userRoleLevels.NoPermission
                )
              }
              isUpgradeable={checkIfUpgradeAble(role, isInternalGlobalUser)}
              accessLevel={accessLevel}
              handleUpgradeClick={() => {
                handleUpgradeClick(userId, name, role)
              }}
              handleDowngradeClick={() => {
                handleDowngradeClick(userId, name, role)
              }}
            />
          )
        )}
      </div>
    </div>
  )
}

export default UserPermissionSubColumn
